import styled, { createGlobalStyle, css } from "styled-components";

export const GlobalStyle = createGlobalStyle`

  html {
    -ms-overflow-style: scrollbar;
    box-sizing: border-box;
  }

  html, #root {
    height: 100%;
    overflow-x: hidden;
    width: 100%;
  }

  body {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    background: ${({ theme }) => theme.colors.color2};
    color: ${({ theme }) => theme.colors.color18};
    font-family: 'DM Sans', sans-serif;
    height: 100%;
    margin: 0;
    padding: 0;
    width: 100%;
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
    margin: 0;
    outline: none;
    padding: 0;
  }

  a {
    color: ${({ theme }) => theme.colors.color18};
    text-decoration: none;
  }

  ul, li {
    list-style: none;
  }

  button {
    -webkit-appearance: none;
    background: transparent;
    border: 0;
  }

`;

export const Container = styled.div`
    width: 1920px;
    height: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;

    ${({ noPadding }) => noPadding && "padding:0"};
`;

export const Col = styled.div`
    max-width: 100%;
    padding-left: 15px;
    padding-right: 15px;
    position: relative;
    width: 100%;

    ${({ fullHeight }) => fullHeight && "height:100%"};

    ${({ noPadding }) =>
        noPadding &&
        css`
            padding-right: 0;
            padding-left: 0;
        `};

    ${({ col1 }) =>
        col1 &&
        css`
            -ms-flex: 0 0 8.333333%;
            flex: 0 0 8.333333%;
            max-width: 8.333333%;
        `};

    ${({ col2 }) =>
        col2 &&
        css`
            -ms-flex: 0 0 16.666667%;
            flex: 0 0 16.666667%;
            max-width: 16.666667%;
        `};

    ${({ col3 }) =>
        col3 &&
        css`
            -ms-flex: 0 0 25%;
            flex: 0 0 25%;
            max-width: 25%;
        `};

    ${({ col4 }) =>
        col4 &&
        css`
            -ms-flex: 0 0 33.333333%;
            flex: 0 0 33.333333%;
            max-width: 33.333333%;
        `};

    ${({ col5 }) =>
        col5 &&
        css`
            -ms-flex: 0 0 41.666667%;
            flex: 0 0 41.666667%;
            max-width: 41.666667%;
        `};

    ${({ col6 }) =>
        col6 &&
        css`
            -ms-flex: 0 0 50%;
            flex: 0 0 50%;
            max-width: 50%;
        `};

    ${({ col7 }) =>
        col7 &&
        css`
            -ms-flex: 0 0 58.333333%;
            flex: 0 0 58.333333%;
            max-width: 58.333333%;
        `};

    ${({ col8 }) =>
        col8 &&
        css`
            -ms-flex: 0 0 66.666667%;
            flex: 0 0 66.666667%;
            max-width: 66.666667%;
        `};

    ${({ col9 }) =>
        col9 &&
        css`
            -ms-flex: 0 0 75%;
            flex: 0 0 75%;
            max-width: 75%;
        `};

    ${({ col10 }) =>
        col10 &&
        css`
            -ms-flex: 0 0 83.333333%;
            flex: 0 0 83.333333%;
            max-width: 83.333333%;
        `};

    ${({ col11 }) =>
        col11 &&
        css`
            -ms-flex: 0 0 91.666667%;
            flex: 0 0 91.666667%;
            max-width: 91.666667%;
        `};

    ${({ col12 }) =>
        col12 &&
        css`
            -ms-flex: 0 0 100%;
            flex: 0 0 100%;
            max-width: 100%;
        `};
`;

export const Row = styled.div`
    -ms-flex-wrap: wrap;
    display: -ms-flexbox;
    display: flex;
    flex-wrap: wrap;
    margin-left: -15px;
    ${({ fullHeight }) => fullHeight && "height:100%"};

    ${({ noMargin }) =>
        noMargin &&
        css`
            margin-left: 0;
            margin-right: 0;
        `};
`;

export const MainContent = styled(Col)`
    background-color: ${({ theme }) => theme.colors.color2};
    height: 100%;
    padding: 0;
`;

export const PageContent = styled.div`
    height: calc(100% - 81px) !important; // - header height
    background-image: linear-gradient(180deg, ${({ theme }) => theme.colors.color32} 0%, ${({ theme }) => theme.colors.color2} 15%);
    background-repeat: no-repeat;
    background-position: top center;
    position: relative;
    padding: 10px;
    ${({ customBg }) =>
        customBg &&
        css`
            background: ${customBg};
        `}
`;
export const KenoPageContent = styled.div`
    height: 100% !important; // - header height
    background-image: linear-gradient(180deg, ${({ theme }) => theme.colors.color32} 0%, ${({ theme }) => theme.colors.color2} 15%);
    background-repeat: no-repeat;
    background-position: top center;
    position: relative;
    ${({ customBg }) =>
        customBg &&
        css`
            background: ${customBg};
        `}
`;
